import { render, staticRenderFns } from "./LoginSpecialForms.vue?vue&type=template&id=72d8a2e4&scoped=true"
import script from "./LoginSpecialForms.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginSpecialForms.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginSpecialForms.vue?vue&type=style&index=0&id=72d8a2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8a2e4",
  null
  
)

export default component.exports